//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pdpComponentMixin from '~/mixins/pdpComponentMixin'

export default {
  mixins: [pdpComponentMixin],
  props: {
    images: { type: Array, default: () => ([]) }
  },
  data () {
    return {
      leAngles: {
        'sierras-le_hannahwhiteley': [5, 1, 2, 3, 4, 6, 7, 8],
        'classics3-le_mattjones': [5, 1, 2, 3, 4, 6, 7],
        'classics3-le_airton': [5, 1, 2, 3, 4, 9, 7],
        'renegades-le_woodsy': [5, 1, 2, 3, 4, 7, 8, 9, 10],
        'vanguards-le_woodsy': [5, 1, 2, 3, 6, 7, 8, 9],
        'renegades-le_rfu': [5, 1, 2, 3, 4, 6, 7],
        'velans-le_canyon': [5, 1, 2, 3, 6, 7, 4],
        'renegades-le_mclaren': [5, 1, 2, 3, 4, 6, 7],
        'renegades-le_mclarenplus': [5, 1, 2, 3, 4, 6, 7],
        'sierras-le_mclaren': [5, 1, 2, 3, 4, 6, 7],
        'sierras-le_mclarenplus': [5, 1, 2, 3, 4, 6, 7],
        'classics3-le_dr3': [5, 1, 2, 3, 6, 9, 7],
        'sierras-le_ln4': [5, 1, 2, 3, 6, 9, 7]
      },
      currentSlide: 0
    }
  },
  computed: {
    viewAngles () {
      if (this.leMode) return this.getLEAngles()
      return this.images && this.images.length ? this.images : [1]
    },
    extraImages () {
      return this.lePartDetails.extraImages || []
    },
    lifestyleImages () {
      if (this.leMode) return []
      const response = this.$store.getters['product/productImages'](this.skuWithEmptyParts)
      if (!response || typeof response !== 'object') return []
      return [response.image_1, response.image_2].filter(url => url)
    }
  },
  watch: {
    sku () {
      if (this.currentSlide > this.viewAngles.length) {
        this.$nextTick(() => this.$refs.slider.goTo(0, false))
      }
    }
  },
  methods: {
    getLEAngles () {
      return this.leAngles[this.sku] || [5, 1, 2, 3]
    },
    handleSlideChange (slide) {
      this.currentSlide = slide
    },
    goToSlide (slide) {
      this.$refs.slider.goTo(0)
    }
  }
}
